// 2025 Topps Chrome Sapphire Star Wars
// Base + autograph checklist mirror the 2025 Topps Chrome flagship (src/sets/2025-chrome.js);
// Sapphire-exclusive content is the Sapphire Selections insert. Parallel ladders per TraderCracks.
export const SETS = [
  {
    id: "base", type: "base", title: "BASE SET — 200 CARDS",
    parallels: [{id:"green-sapphire",name:"Green Sapphire",print_run:99,color:"#5fd35f"},{id:"gold-sapphire",name:"Gold Sapphire",print_run:50,color:"#f0c040"},{id:"orange-sapphire",name:"Orange Sapphire",print_run:25,color:"#ff9d52"},{id:"purple-sapphire",name:"Purple Sapphire",print_run:15,color:"#cb7dff"},{id:"black-sapphire",name:"Black Sapphire",print_run:10,color:"#a8a8b4"},{id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},{id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"}],
    cards: [
      {n:"1", name:"Admiral Ackbar", artist:null},
      {n:"2", name:"Ahsoka Tano", artist:null},
      {n:"3", name:"Anakin Skywalker", artist:null},
      {n:"4", name:"Arvel Skeen", artist:null},
      {n:"5", name:"Baylan Skoll", artist:null},
      {n:"6", name:"Bazil", artist:null},
      {n:"7", name:"Beru Lars", artist:null},
      {n:"8", name:"Birnok", artist:null},
      {n:"9", name:"Bix Caleen", artist:null},
      {n:"10", name:"Bo-Katan Kryze", artist:null},
      {n:"11", name:"Boba Fett", artist:null},
      {n:"12", name:"Bodhi Rook", artist:null},
      {n:"13", name:"C-3PO", artist:null},
      {n:"14", name:"C1-D1", artist:null},
      {n:"15", name:"Captain Blex", artist:null},
      {n:"16", name:"Captain Elk", artist:null},
      {n:"17", name:"Captain Girard", artist:null},
      {n:"18", name:"Captain Hayle", artist:null},
      {n:"19", name:"Captain Phasma", artist:null},
      {n:"20", name:"Captain Porter", artist:null},
      {n:"21", name:"Captain Silvo", artist:null},
      {n:"22", name:"Cassian Andor", artist:null},
      {n:"23", name:"Chewbacca", artist:null},
      {n:"24", name:"Chirrut Îmwe", artist:null},
      {n:"25", name:"Chopper", artist:null},
      {n:"26", name:"Clone Captain Rex", artist:null},
      {n:"27", name:"Count Dooku", artist:null},
      {n:"28", name:"Darth Maul", artist:null},
      {n:"29", name:"Darth Vader", artist:null},
      {n:"30", name:"Dedra Meero", artist:null},
      {n:"31", name:"Dengar", artist:null},
      {n:"32", name:"Dinghy Driver", artist:null},
      {n:"33", name:"DJ", artist:null},
      {n:"34", name:"Dr. Gorst", artist:null},
      {n:"35", name:"Dryden Vos", artist:null},
      {n:"36", name:"Eedy Karn", artist:null},
      {n:"37", name:"Elder Naasa", artist:null},
      {n:"38", name:"Emperor Palpatine", artist:null},
      {n:"39", name:"Ezra Bridger", artist:null},
      {n:"40", name:"Fara", artist:null},
      {n:"41", name:"Fennec Shand", artist:null},
      {n:"42", name:"Fern", artist:null},
      {n:"43", name:"Fifth Brother Inquisitor", artist:null},
      {n:"44", name:"Fillik", artist:null},
      {n:"45", name:"Finn", artist:null},
      {n:"46", name:"First Officer Jensen Corbyt", artist:null},
      {n:"47", name:"Galen Erso", artist:null},
      {n:"48", name:"Garsa Fwip", artist:null},
      {n:"49", name:"General Grievous", artist:null},
      {n:"50", name:"General Hux", artist:null},
      {n:"51", name:"General Pryde", artist:null},
      {n:"52", name:"Grand Admiral Thrawn", artist:null},
      {n:"53", name:"Grand Moff Tarkin", artist:null},
      {n:"54", name:"Greedo", artist:null},
      {n:"55", name:"Greef Karga", artist:null},
      {n:"56", name:"Grogu", artist:null},
      {n:"57", name:"Gunter", artist:null},
      {n:"58", name:"Han Solo", artist:null},
      {n:"59", name:"Hera Syndulla", artist:null},
      {n:"60", name:"IG-11", artist:null},
      {n:"61", name:"Indara", artist:null},
      {n:"62", name:"Jabba The Hutt", artist:null},
      {n:"63", name:"Jar Jar Binks", artist:null},
      {n:"64", name:"Jecki Lon", artist:null},
      {n:"65", name:"Jod Na Nawood", artist:null},
      {n:"66", name:"Jyn Erso", artist:null},
      {n:"67", name:"K-2SO", artist:null},
      {n:"68", name:"Karis Nemik", artist:null},
      {n:"69", name:"Kassa", artist:null},
      {n:"70", name:"Kawlan Roken", artist:null},
      {n:"71", name:"Kaydel Connix", artist:null},
      {n:"72", name:"Kelleran Beq", artist:null},
      {n:"73", name:"Kelnacca", artist:null},
      {n:"74", name:"Kh'ymm", artist:null},
      {n:"75", name:"Klothow", artist:null},
      {n:"76", name:"Koska Reeves", artist:null},
      {n:"77", name:"L3-37", artist:null},
      {n:"78", name:"Lando Calrissian", artist:null},
      {n:"79", name:"Lando Calrissian", artist:null},
      {n:"80", name:"Leia Organa", artist:null},
      {n:"81", name:"Logray", artist:null},
      {n:"82", name:"Lor San Tekka", artist:null},
      {n:"83", name:"Luke Skywalker", artist:null},
      {n:"84", name:"Luthen Rael", artist:null},
      {n:"85", name:"Mace Windu", artist:null},
      {n:"86", name:"Mae Aniseya", artist:null},
      {n:"87", name:"Maree", artist:null},
      {n:"88", name:"Master Codebreaker", artist:null},
      {n:"89", name:"Max Rebo", artist:null},
      {n:"90", name:"Maz Kanata", artist:null},
      {n:"91", name:"Moff Gideon", artist:null},
      {n:"92", name:"Mog Adana", artist:null},
      {n:"93", name:"Mon Mothma", artist:null},
      {n:"94", name:"Mother Aniseya", artist:null},
      {n:"95", name:"Mother Koril", artist:null},
      {n:"96", name:"Nol", artist:null},
      {n:"97", name:"Pokkit", artist:null},
      {n:"98", name:"Skull Ridge Mountain Hotelier", artist:null},
      {n:"99", name:"SM-33", artist:null},
      {n:"100", name:"Trash crab", artist:null},
      {n:"101", name:"2-1B Droid", artist:null},
      {n:"102", name:"Adi Gallia", artist:null},
      {n:"103", name:"Aemon Gremm", artist:null},
      {n:"104", name:"Bazine Netal", artist:null},
      {n:"105", name:"BB-9E", artist:null},
      {n:"106", name:"Beaumont Kin", artist:null},
      {n:"107", name:"Benjar Pranic", artist:null},
      {n:"108", name:"Bossk", artist:null},
      {n:"109", name:"Brasso", artist:null},
      {n:"110", name:"Cabuck", artist:null},
      {n:"111", name:"Chancellor Drellik", artist:null},
      {n:"112", name:"Chief Chirpa", artist:null},
      {n:"113", name:"Darth Bane", artist:null},
      {n:"114", name:"Dokk Strassi", artist:null},
      {n:"115", name:"Enfys Nest", artist:null},
      {n:"116", name:"Figrin D'an", artist:null},
      {n:"117", name:"Fuzzball", artist:null},
      {n:"118", name:"Fyrnock", artist:null},
      {n:"119", name:"General Pong Krell", artist:null},
      {n:"120", name:"General Strix", artist:null},
      {n:"121", name:"Glerb", artist:null},
      {n:"122", name:"Hayna", artist:null},
      {n:"123", name:"Hondo Ohnaka", artist:null},
      {n:"124", name:"IG-88", artist:null},
      {n:"125", name:"Jawa", artist:null},
      {n:"126", name:"Jess Pava", artist:null},
      {n:"127", name:"Kayo Organa", artist:null},
      {n:"128", name:"KB", artist:null},
      {n:"129", name:"Kona", artist:null},
      {n:"130", name:"Kragan Gorr", artist:null},
      {n:"131", name:"Lobot", artist:null},
      {n:"132", name:"Lortha Peel", artist:null},
      {n:"133", name:"Mas Amedda", artist:null},
      {n:"134", name:"Mayor Mok Shaiz", artist:null},
      {n:"135", name:"Melna", artist:null},
      {n:"136", name:"Mother Talzin", artist:null},
      {n:"137", name:"Neel", artist:null},
      {n:"138", name:"Obi-Wan Kenobi", artist:null},
      {n:"139", name:"Obi-Wan Kenobi", artist:null},
      {n:"140", name:"Osha Aniseya", artist:null},
      {n:"141", name:"Padmé Amidala", artist:null},
      {n:"142", name:"Pegla", artist:null},
      {n:"143", name:"Pip", artist:null},
      {n:"144", name:"Pirate Captain Brutus", artist:null},
      {n:"145", name:"Poe Dameron", artist:null},
      {n:"146", name:"Poggle the Lesser", artist:null},
      {n:"147", name:"Porg", artist:null},
      {n:"148", name:"Professor Huyang", artist:null},
      {n:"149", name:"Pyke Boss", artist:null},
      {n:"150", name:"Qi'ra", artist:null},
      {n:"151", name:"Queen Apailana", artist:null},
      {n:"152", name:"Qui-Gon Jinn", artist:null},
      {n:"153", name:"R2-D2", artist:null},
      {n:"154", name:"Ragnar Vizsla", artist:null},
      {n:"155", name:"Rey", artist:null},
      {n:"156", name:"Rio Durant", artist:null},
      {n:"157", name:"Roona", artist:null},
      {n:"158", name:"Rose Tico", artist:null},
      {n:"159", name:"Sabé", artist:null},
      {n:"160", name:"Sabine Wren", artist:null},
      {n:"161", name:"Safety Droid", artist:null},
      {n:"162", name:"Savage Opress", artist:null},
      {n:"163", name:"Senator Rayencourt", artist:null},
      {n:"164", name:"Sergeant Linus Mosk", artist:null},
      {n:"165", name:"Shaak Ti", artist:null},
      {n:"166", name:"Shin Hati", artist:null},
      {n:"167", name:"Skura", artist:null},
      {n:"168", name:"Slowen Lo", artist:null},
      {n:"169", name:"Sly Moore", artist:null},
      {n:"170", name:"Snowball", artist:null},
      {n:"171", name:"Sol", artist:null},
      {n:"172", name:"Sully Stark", artist:null},
      {n:"173", name:"Supreme Leader Kylo Ren", artist:null},
      {n:"174", name:"Supreme Leader Snoke", artist:null},
      {n:"175", name:"Tasi Lowa", artist:null},
      {n:"176", name:"Teacher Droid", artist:null},
      {n:"177", name:"Tera Sinube", artist:null},
      {n:"178", name:"The Armorer", artist:null},
      {n:"179", name:"The Client", artist:null},
      {n:"180", name:"The Grand Inquisitor", artist:null},
      {n:"181", name:"The Mandalorian", artist:null},
      {n:"182", name:"The Stranger", artist:null},
      {n:"183", name:"Tion Medon", artist:null},
      {n:"184", name:"Tobias Beckett", artist:null},
      {n:"185", name:"Torbin", artist:null},
      {n:"186", name:"Unkar Plutt", artist:null},
      {n:"187", name:"Val", artist:null},
      {n:"188", name:"Vernestra Rwoh", artist:null},
      {n:"189", name:"Vetch", artist:null},
      {n:"190", name:"Watto", artist:null},
      {n:"191", name:"Wendle", artist:null},
      {n:"192", name:"Wilmon Paak", artist:null},
      {n:"193", name:"Wim", artist:null},
      {n:"194", name:"Wullf Yularen", artist:null},
      {n:"195", name:"Xanwan", artist:null},
      {n:"196", name:"Yarael Poof", artist:null},
      {n:"197", name:"Yoda", artist:null},
      {n:"198", name:"Yord Fandar", artist:null},
      {n:"199", name:"Zam Wesell", artist:null},
      {n:"200", name:"Zorii Bliss", artist:null},
    ]
  },
  {
    id: "sapphire-selections", type: "insert", title: "SAPPHIRE SELECTIONS — 10 CARDS",
    parallels: [{id:"orange-sapphire",name:"Orange Sapphire",print_run:25,color:"#ff9d52"},{id:"purple-sapphire",name:"Purple Sapphire",print_run:15,color:"#cb7dff"},{id:"black-sapphire",name:"Black Sapphire",print_run:10,color:"#a8a8b4"},{id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},{id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"}],
    cards: [
      {n:"SS-1", name:"Boba Fett", artist:null},
      {n:"SS-2", name:"Bo-Katan Kryze", artist:null},
      {n:"SS-3", name:"C-3PO", artist:null},
      {n:"SS-4", name:"Cassian Andor", artist:null},
      {n:"SS-5", name:"Chewbacca", artist:null},
      {n:"SS-6", name:"Grogu", artist:null},
      {n:"SS-7", name:"Lando Calrissian", artist:null},
      {n:"SS-8", name:"Poe Dameron", artist:null},
      {n:"SS-9", name:"Qi'ra", artist:null},
      {n:"SS-10", name:"Rey", artist:null},
    ]
  },
  {
    id: "autograph-cards", type: "auto", title: "AUTOGRAPH CARDS — 122 CARDS",
    parallels: [{id:"blue-sapphire",name:"Blue Sapphire",print_run:5,color:"#5f8dff"},{id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"}],
    cards: [
      {n:"A-SLKR", name:"Supreme Leader Kylo Ren", artist:null},
      {n:"A-AA", name:"Bix Caleen", artist:null},
      {n:"A-AW", name:"Mortis Daughter", artist:null},
      {n:"A-AB", name:"Kelleran Beq", artist:null},
      {n:"A-ABE", name:"Jar Jar Binks", artist:null},
      {n:"A-AF", name:"Sergeant Linus Mosk", artist:null},
      {n:"A-AL", name:"Karis Nemik", artist:null},
      {n:"A-AP", name:"General Draven", artist:null},
      {n:"A-AM", name:"Aayla Secura", artist:null},
      {n:"A-SE", name:"Peli Motto", artist:null},
      {n:"A-ASE", name:"Kino Loy", artist:null},
      {n:"A-SLS", name:"Supreme Leader Snoke", artist:null},
      {n:"A-AN", name:"Bazine Netal", artist:null},
      {n:"A-AD", name:"C-3PO", artist:null},
      {n:"A-LE", name:"Major Partagaz", artist:null},
      {n:"A-AV", name:"Kassa", artist:null},
      {n:"A-BL", name:"Kaydel Connix", artist:null},
      {n:"A-BDW", name:"Lando Calrissian", artist:null},
      {n:"A-BLA", name:"Beru Lars", artist:null},
      {n:"A-CJ", name:"Gorian Shard", artist:null},
      {n:"A-CAM", name:"Indara", artist:null},
      {n:"A-CH", name:"Yord Fandar", artist:null},
      {n:"A-CBA", name:"C1-D1", artist:null},
      {n:"A-CB", name:"Klothow", artist:null},
      {n:"A-DK", name:"Jecki Lon", artist:null},
      {n:"A-DR", name:"Rey", artist:null},
      {n:"A-DCA", name:"B2EMO", artist:null},
      {n:"A-DB", name:"Jabba The Hutt", artist:null},
      {n:"A-DCC", name:"Torbin", artist:null},
      {n:"A-DER", name:"Droopy McCool", artist:null},
      {n:"A-DGO", name:"Dedra Meero", artist:null},
      {n:"A-DLR", name:"Morgan Elsbeth", artist:null},
      {n:"A-DL", name:"Cassian Andor", artist:null},
      {n:"A-DGR", name:"General Hux", artist:null},
      {n:"A-EE", name:"Ezra Bridger", artist:null},
      {n:"A-ES", name:"The Armorer", artist:null},
      {n:"A-EK", name:"Enfys Nest", artist:null},
      {n:"A-EM", name:"Obi-Wan Kenobi", artist:null},
      {n:"A-FM", name:"Vel Sartha", artist:null},
      {n:"A-FJ", name:"Jyn Erso", artist:null},
      {n:"A-FS", name:"Maarva Andor", artist:null},
      {n:"A-FW", name:"Saw Gerrera", artist:null},
      {n:"A-FT", name:"Captain Brutus", artist:null},
      {n:"A-GB", name:"Clem Andor", artist:null},
      {n:"A-GOR", name:"Mon Mothma", artist:null},
      {n:"A-GE", name:"Moff Gideon", artist:null},
      {n:"A-GH", name:"Grand Moff Tarkin", artist:null},
      {n:"A-GC", name:"Captain Phasma", artist:null},
      {n:"A-HF", name:"Han Solo", artist:null},
      {n:"A-HC", name:"Anakin Skywalker", artist:null},
      {n:"A-IM", name:"Emperor Palpatine", artist:null},
      {n:"A-IW", name:"Vetch", artist:null},
      {n:"A-IS", name:"Shin Hati", artist:null},
      {n:"A-JC", name:"Toro Calican", artist:null},
      {n:"A-JAL", name:"Gunter", artist:null},
      {n:"A-JE", name:"Owen Lars", artist:null},
      {n:"A-JR", name:"Major Bren Derlin", artist:null},
      {n:"A-JS", name:"Kelnacca", artist:null},
      {n:"A-LAW", name:"Jod Na Nawood", artist:null},
      {n:"A-KCS", name:"Rabé", artist:null},
      {n:"A-KS", name:"Bo-Katan Kryze", artist:null},
      {n:"A-KCH", name:"Queen Apailana", artist:null},
      {n:"A-K", name:"Pokkit", artist:null},
      {n:"A-KMT", name:"Rose Tico", artist:null},
      {n:"A-KC", name:"Admiral Piett", artist:null},
      {n:"A-KR", name:"Zorii Bliss", artist:null},
      {n:"A-KOB", name:"Pegla", artist:null},
      {n:"A-LM", name:"Grand Admiral Thrawn", artist:null},
      {n:"A-LD", name:"Vice Admiral Holdo", artist:null},
      {n:"A-LJJ", name:"Sol", artist:null},
      {n:"A-LL", name:"Major Vonreg", artist:null},
      {n:"A-LN", name:"Maz Kanata", artist:null},
      {n:"A-MJ", name:"The Stranger", artist:null},
      {n:"A-MVE", name:"Vult Skerris", artist:null},
      {n:"A-MH", name:"Luke Skywalker", artist:null},
      {n:"A-MR", name:"Captain Hayle", artist:null},
      {n:"A-M", name:"Poggle the Lesser", artist:null},
      {n:"A-MEW", name:"Hera Syndulla", artist:null},
      {n:"A-MO", name:"Luminara Unduli", artist:null},
      {n:"A-MW", name:"General Grievous", artist:null},
      {n:"A-MA", name:"Sully Stark", artist:null},
      {n:"A-MSA", name:"Barriss Offee", artist:null},
      {n:"A-MC", name:"Even Piell", artist:null},
      {n:"A-MAG", name:"Omega", artist:null},
      {n:"A-MQ", name:"Nien Nunb", artist:null},
      {n:"A-MNW", name:"Fennec Shand", artist:null},
      {n:"A-MI", name:"Reva", artist:null},
      {n:"A-MB", name:"Wilmon Paak", artist:null},
      {n:"A-NP", name:"Padmé Amidala", artist:null},
      {n:"A-NLB", name:"Sabine Wren", artist:null},
      {n:"A-FRO", name:"SM-33", artist:null},
      {n:"A-AJ", name:"Asajj Ventress", artist:null},
      {n:"A-OSJ", name:"Kawlan Roken", artist:null},
      {n:"A-OS", name:"Shaak Ti", artist:null},
      {n:"A-OI", name:"Poe Dameron", artist:null},
      {n:"A-PB", name:"Greedo", artist:null},
      {n:"A-PD", name:"Marrok", artist:null},
      {n:"A-PP", name:"The Mandalorian", artist:null},
      {n:"A-MWE", name:"Myn Weaver", artist:null},
      {n:"A-PL", name:"Kit Fisto", artist:null},
      {n:"A-RAB", name:"Queen Miraj Scintel", artist:null},
      {n:"A-RCC", name:"Wim", artist:null},
      {n:"A-RP", name:"Darth Maul", artist:null},
      {n:"A-RH", name:"Vernestra Rwoh", artist:null},
      {n:"A-RA", name:"Bodhi Rook", artist:null},
      {n:"A-RTS", name:"Neel", artist:null},
      {n:"A-RD", name:"Ahsoka Tano", artist:null},
      {n:"A-RF", name:"The Grand Inquisitor", artist:null},
      {n:"A-RK", name:"Fourth Sister Inquisitor", artist:null},
      {n:"A-SWIT", name:"Dinghy Driver", artist:null},
      {n:"A-SLJ", name:"Mace Windu", artist:null},
      {n:"A-SP", name:"Unkar Plutt", artist:null},
      {n:"A-SW", name:"Max Rebo", artist:null},
      {n:"A-SI", name:"Breha Organa", artist:null},
      {n:"A-SS", name:"Luthen Rael", artist:null},
      {n:"A-TW", name:"IG-11", artist:null},
      {n:"A-TM", name:"Boba Fett", artist:null},
      {n:"A-TO", name:"Cobb Vanth", artist:null},
      {n:"A-TAD", name:"Wendle", artist:null},
      {n:"A-WD", name:"Wicket W. Warrick", artist:null},
      {n:"A-WE", name:"The Client", artist:null},
      {n:"A-ZV", name:"Xanwan", artist:null},
    ]
  },
  {
    id: "duo-autographs", type: "auto", title: "DUO AUTOGRAPHS — 15 CARDS",
    parallels: [{id:"blue-sapphire",name:"Blue Sapphire",print_run:5,color:"#5f8dff"},{id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"}],
    cards: [
      {n:"DA-AD", name:"General Hux & Supreme Leader Snoke", artist:null},
      {n:"DA-BD", name:"Kaydel Connix & Beaumont Kin", artist:null},
      {n:"DA-CB", name:"Jecki Lon & Yord Fandar", artist:null},
      {n:"DA-CL", name:"Indara & Sol", artist:null},
      {n:"DA-DSK", name:"Luthen Rael & Cassian Andor", artist:null},
      {n:"DA-EP", name:"The Mandalorian & The Armorer", artist:null},
      {n:"DA-FM", name:"Saw Gerrera & Galen Erso", artist:null},
      {n:"DA-ID", name:"Shin Hati & Morgan Elsbeth", artist:null},
      {n:"DA-JA", name:"Peli Motto & Toro Calican", artist:null},
      {n:"DA-KB", name:"Rose Tico & DJ", artist:null},
      {n:"DA-MJj", name:"Sol & The Stranger", artist:null},
      {n:"DA-NJ", name:"SM-33 & Jod Na Nawood", artist:null},
      {n:"DA-RM", name:"The Stranger & Vernestra Rwoh", artist:null},
      {n:"DA-SD", name:"Unkar Plutt & Rey", artist:null},
      {n:"DA-WG", name:"Moff Gideon & The Client", artist:null},
    ]
  },
  {
    id: "trio-autographs", type: "auto", title: "TRIO AUTOGRAPHS — 11 CARDS",
    parallels: [{id:"blue-sapphire",name:"Blue Sapphire",print_run:5,color:"#5f8dff"},{id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"}],
    cards: [
      {n:"TA-CJD", name:"Krrsantan, Garsa Fwip & Twi'lek Majordomo", artist:null},
      {n:"TA-EMR", name:"Obi-Wan Kenobi, Reva & The Grand Inquisitor", artist:null},
      {n:"TA-ENM", name:"Hera Syndulla, Ezra Bridger & Sabine Wren", artist:null},
      {n:"TA-FVG", name:"Mon Mothma, Vel Sartha & Cinta Kaz", artist:null},
      {n:"TA-FZI", name:"Vetch, Xanwan & Maarva Andor", artist:null},
      {n:"TA-HES", name:"Anakin Skywalker, Mace Windu & Obi-Wan Kenobi", artist:null},
      {n:"TA-JRN", name:"Neel, Jod Na Nawood & SM-33", artist:null},
      {n:"TA-JSM", name:"The Modifier, Fennec Shand & Skad", artist:null},
      {n:"TA-KDA", name:"Sergeant Linus Mosk, Syril Karn & Dedra Meero", artist:null},
      {n:"TA-MDN", name:"Asajj Ventress, Omega & Hunter", artist:null},
      {n:"TA-WTN", name:"Kuill, IG-11 & The Client", artist:null},
    ]
  }
];
